import { createEssay } from '../../../core/queries/essays-queries/essayFunction';
import { useMutation } from '@tanstack/react-query';

export function useCreateEssay() {
  const { mutate, isPending, isError, data } = useMutation({
    mutationKey: ['createEssay'], 
    mutationFn: (body: { theme: string, moduleOrigin: string }) => createEssay(body),
    retry: false
  });

  return { mutate, isPending, isError, data };
}
